import { render, staticRenderFns } from "./BaseScrollToTop.vue?vue&type=template&id=550e28bc&scoped=true&"
import script from "./BaseScrollToTop.vue?vue&type=script&lang=js&"
export * from "./BaseScrollToTop.vue?vue&type=script&lang=js&"
import style0 from "./BaseScrollToTop.vue?vue&type=style&index=0&id=550e28bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550e28bc",
  null
  
)

export default component.exports